import * as z from "zod";

export const getRefreshTeamRatesProgress = {
  name: "getRefreshTeamRatesProgress" as const,
  input: z.object({}),
  output: z.object({
    refresh: z
      .object({ total: z.number(), started: z.number(), startTime: z.string() })
      .nullable(),
  }),
};
